module.exports = __webpack_public_path__ + "static/fa4-e967281c5486376cadd570bcf7ff6379.jpg";